<template>
    <div>
        <dialog ref="dialogRef1">
            <p>{{question1}}</p>
            <textarea name="" id="" cols="30" rows="10" v-model="textarea1"></textarea>
            <button class="bg-red-600 text-white pl-1 pr-1" @click="closeDialog1">Close</button>
        </dialog>
        <dialog ref="dialogRef2">
            <p>{{question2}}</p>
            <textarea name="" id="" cols="30" rows="10" v-model="textarea2"></textarea>
            <button class="bg-red-600 text-white pl-1 pr-1" @click="closeDialog2">close</button>
        </dialog>
        <dialog ref="dialogRef3">
            <p>{{question3}}</p>
            <textarea name="" id="" cols="30" rows="10" v-model="textarea3"></textarea>
            <button class="bg-red-600 text-white pl-1 pr-1" @click="closeDialog3">close</button>
        </dialog>
        <dialog ref="dialogRef4">
            <p>{{question4}}</p>
            <textarea name="" id="" cols="30" rows="10" v-model="textarea4"></textarea>
            <button class="bg-red-600 text-white pl-1 pr-1" @click="closeDialog4">close</button>
        </dialog>
        <dialog ref="dialogRef5">
            <p>{{question5}}</p>
            <textarea name="" id="" cols="30" rows="10" v-model="textarea5"></textarea>
            <button class="bg-red-600 text-white pl-1 pr-1" @click="closeDialog5">close</button>
        </dialog>
        <div class="pl-12 pt-12 pr-12 ">
            <div class="pl-5 md:pl-0 bg-gradient-to-r from-red-600">
                <h3 class="text-white text-lg font-semibold">Key priorities and Planning</h3>
            </div>
            <div class="pl-5 md:pl-0">
                <p class="font-semibold">This planning template will allow schools to accurately plan their spending.</p>
            </div>
            <div class="md:block hidden">
                <table>
                    <tr>
                        <th class="border-2 border-black">
                            {{question1}}
                        </th>
                        <th class="border-2 border-black">
                            {{question2}}
                        </th>
                        <th class="border-2 border-black">
                            {{question3}}
                        </th>
                        <th class="border-2 border-black">
                            {{question4}}
                        </th>
                        <th class="border-2 border-black">
                            {{question5}}
                        </th>
                    </tr>
                    <tr>
                        <td @click="showDialog1" class="cursor-pointer border-2 border-black">{{ answer1() }}</td>
                        <td @click="showDialog2" class="cursor-pointer border-2 border-black">{{ answer2() }}</td>
                        <td @click="showDialog3" class="cursor-pointer border-2 border-black">{{ answer3() }}</td>
                        <td @click="showDialog4" class="cursor-pointer border-2 border-black">{{ answer4() }}</td>
                        <td @click="showDialog5" class="cursor-pointer border-2 border-black">{{ answer5() }}</td>
                    </tr>

                </table>
            </div>
            <div class="pl-5 md:pl-0 block sm:hidden">
                <div>
                    <tr>
                        <th class="border-2 border-black">
                            {{question1}}
                        </th>
                    </tr>
                    <tr>
                        <td @click="showDialog1" class="cursor-pointer border-2 border-black">
                            {{ answer1() }}
                        </td>
                    </tr>
                </div>
                <div>
                    <tr>
                        <th class="border-2 border-black">
                            {{question2}}
                        </th>
                    </tr>
                    <tr>
                        <td @click="showDialog2" class="cursor-pointer border-2 border-black">
                            {{ answer2() }}
                        </td>
                    </tr>
                </div>
                <div>
                    <tr>
                        <th class="border-2 border-black">
                            {{question3}}
                        </th>
                    </tr>
                    <tr>
                        <td @click="showDialog3" class="cursor-pointer border-2 border-black">
                            {{ answer3() }}
                        </td>
                    </tr>
                </div>
                <div>
                    <tr>
                        <th class="border-2 border-black">
                            {{question4}}
                        </th>
                    </tr>
                    <tr>
                        <td @click="showDialog4" class="cursor-pointer border-2 border-black">
                            {{ answer4() }}
                        </td>
                    </tr>
                </div>
                <div>
                    <tr>
                        <th class="border-2 border-black">
                            {{question5}}
                        </th>
                    </tr>
                    <tr>
                        <td @click="showDialog5" class="cursor-pointer border-2 border-black">
                            {{ answer5() }}
                        </td>
                    </tr>
                </div>
            </div>
        </div>
        <div class="flex pl-12 pt-3">
            <h3 class="pl-5 md:pl-0">Created by:</h3>
            <img class="max-w-1/3" src="@/assets/images/afPE.png" alt="">
            <img class="max-w-1/3" src="@/assets/images/YST.png" alt="">
        </div>
    </div>
</template>
<script>
export default{
        name: "AfpeReport",
        data(){
            return {
                td1: "e.g. Introduce lunchtime sport sessions/activities for pupils.",
                td2: "Lunchtime supervisors / teaching staff, coaches - as they need to lead the activity pupils - as they will take part.",
                td3: "Key indicator 2 - The engagement of all pupils in regular physical activity - the Chief Medical Officer guidelines recommend that all children and young people aged 5 to 18 engage in at least 60 minutes of physical activity per day, of which 30 minutes should be in school. Key indicator 4: Broader experience of a range of sports and activities offered to all pupils.",
                td4: "More pupils meeting their daily physical activity goal, more pupils encouraged to take part in PE and Sport Activities.",
                td5: "1000 costs for additional coaches to support lunchtime sessions.",
                textarea1: "",
                textarea2: "",
                textarea3: "",
                textarea4: "",
                textarea5: "",
                question1: "Action - what are you planning to do?",
                question2: "Who does this action impact?",
                question3: "Key indicator to meet",
                question4: "Impacts and how sustainability will be achieved?",
                question5: "Cost linked to the action"
            }
        },
        methods: {
            showDialog1(){
                this.$refs.dialogRef1.showModal()
                console.log(this.$store.state.auth)
            },
            showDialog2(){
                this.$refs.dialogRef2.showModal()
            },
            showDialog3(){
                this.$refs.dialogRef3.showModal()
            },
            showDialog4(){
                this.$refs.dialogRef4.showModal()
            },
            showDialog5(){
                this.$refs.dialogRef5.showModal()
            },
            closeDialog1(){
                this.$refs.dialogRef1.close()
            },
            closeDialog2(){
                this.$refs.dialogRef2.close()
            },
            closeDialog3(){
                this.$refs.dialogRef3.close()
            },
            closeDialog4(){
                this.$refs.dialogRef4.close()
            },
            closeDialog5(){
                this.$refs.dialogRef5.close()
            },
            answer1(){
                if(this.textarea1.trim().length > 0){
                    return this.textarea1
                } else {
                    return this.td1
                }
            },
            answer2(){
                if(this.textarea2.trim().length > 0){
                    return this.textarea2
                } else {
                    return this.td2
                }
            },
            answer3(){
                if(this.textarea3.trim().length > 0){
                    return this.textarea3
                } else {
                    return this.td3
                }
            },
            answer4(){
                if(this.textarea4.trim().length > 0){
                    return this.textarea4
                } else {
                    return this.td4
                }
            },
            answer5(){
                if(this.textarea5.trim().length > 0){
                    return this.textarea5
                } else {
                    return this.td5
                }
            }
        }
    }
</script>
<style scoped>

</style>